import { apiGet, throwApiError } from "../utils";

export const TransactionType = Object.freeze({
  Purchase: "purchase",
  Spend: "spend",
  Refund: "refund",
  Grant: "grant",
  Revoke: "revoke",
  Payout: "payout",
});

export const getTransactions = async (
  page,
  perPage,
  _search = "",
  filters = {},
) => {
  const params = { page, perPage };

  if (filters.type) {
    params.type = filters.type;
  }

  if (filters.sortOrder) {
    params.sortOrder = filters.sortOrder;
  }

  const response = await apiGet("/wallet/admin/transactions", params);
  const { items, totalCount, message } = await response.json();

  throwApiError(message);

  return { items, totalCount };
};
